<template>
  <div class="page">
    <div class="d_c">
        <p>短信套餐列表</p>
        <span class="rt-pos" @click="back"></span>
    </div>
    <div class="divHeight"></div>
    <nut-row class="msg-msisdn" style="border-bottom: 1px solid #e2e2e2;">
        <nut-col :span="24">
            <span>业务号：</span>
            <span>{{msisdn}}</span>
        </nut-col>
    </nut-row>
    <nut-row class="msg-msisdn">
        <nut-col :span="24">
            <span>ICCID：</span>
            <span>{{iccid}}</span>
        </nut-col>
    </nut-row>
    <div class="divHeight"></div>
    <nut-row class="msg-product-title">
        <nut-col :span="24">
            <span>请选择套餐</span>
        </nut-col>
    </nut-row>
    <div class="msg-product-container">
      <nut-row class="row-product" v-for="(item,index) in packageList" :key="index">
        <nut-col :span="3" class="row-product-radio" align="center">
          <nut-radio
            v-model="product"
            :label="item.productId"
            @click.native.stop="selectProduct(item)"
          >
          </nut-radio>
        </nut-col>
        <nut-col :span="21">
          <nut-row>
            <nut-col :span="18">{{item.productName}}</nut-col>
            <nut-col :offset="-1" :span="5" align="right">
              <nut-price 
                  :price="item.price" 
                  :needSymbol="true" 
                  :thousands="true"
              />
            </nut-col>
          </nut-row>
          <nut-row>
            <nut-col :span="19" class="row-product-desc">{{item.remark}}</nut-col>
            <nut-col :offset="-1" :span="4" align="right" class="row-product-show">￥{{item.showPrice}}</nut-col>
          </nut-row>
        </nut-col>
      </nut-row>
      
    </div>
    <nut-button block shape="circle" class="msg-button-pay" @click="pay">确认支付</nut-button>
  </div>
</template>
<script>
import { wx_getproduct,wxPaySms} from "@/api/api.js"; //获取套餐
import wx from "weixin-js-sdk";
import { wx_Auth } from "@/api/api.js"; //获取微信信息
export default {
  name:'msgProduct',
  data() {
    return {
      cardIndex:0,
      description:false,
      packageList:[],
      msisdn:"",
      iccid:"",
      wechatId:"",
      propsParams:{},
      product:1,
    };
  },
  computed: {},
  methods: {
    // 后退到上一页
    back(){
      this.$router.go(-1);
    },
    // 获取套餐
    initProduct(){
      this.$toast.loading('加载中...',{ 
        duration:200,
        coverColor: "rgba(0,0,0,0.5)",
        closeOnClickOverlay: true,
        loadingRotate:true
      });
      let params ={
        iccid:this.$route.query.iccid,
        type:"4",
        channel:localStorage.getItem("channel")
      }
      wx_getproduct(params).then(res => {
        if(res.data.code == 200){
          this.packageList = res.data.data.productList;
          this.msisdn = res.data.data.msisdn;
          this.iccid = res.data.data.iccid;
          this.wechatId = res.data.data.appId;
          if(this.packageList.length > 0){
            this.propsParams = res.data.data.productList[0];
            this.product = res.data.data.productList[0].productId;
          }
        }else{
          this.$toast.fail(res.data.message);
        }
      })
    },
    //获取微信信息
    handelWxConfig() {
      let params = {
        url: window.location.href,
        channel:localStorage.getItem("channel")
      };
      wx_Auth(params).then(res => {
        let dataObj = res.data.data;
        this.datas = res.data.data;
        let getAppid = dataObj.appId;
        let getTimestamp = dataObj.timestamp;
        let getNonceStr = dataObj.nonceStr;
        let getSignature = dataObj.signature;
        wx.config({
          debug: false,
          appId: getAppid,
          timestamp: getTimestamp,
          nonceStr: getNonceStr,
          signature: getSignature,
          jsApiList: ["chooseWXPay"]
        });
        wx.ready(function() {
          wx.checkJsApi({
            jsApiList: ["chooseWXPay"],
            success: function(res) {}
          });
        });
      });
    },
    // 切换列表
    selectProduct(item){
      this.propsParams = item;
    },
    // 去充值 
    pay(){
      if(!!this.propsParams.productId){
        console.log("propsParams:",this.propsParams);
          let params ={
            iccid:this.iccid,
            price:this.propsParams.price,
            productId:this.propsParams.productId,
            ip:"11.28.33.12",
          }
          if(this.isWeiXin()){
            this.handelWxConfig();
            params.code = localStorage.getItem("code");
            params.type = "JSAPI";
            params.channel = localStorage.getItem("channel")
          }else{
            params.type = "MWEB";
          }
          let that = this;
          wxPaySms(params).then(res=>{
            if (res.data.code == 200) {
              if(this.isWeiXin()){
                wx.chooseWXPay({
                  timestamp: res.data.data.timeStamp,
                  nonceStr: res.data.data.nonceStr, 
                  package: res.data.data.packageValue, 
                  signType: res.data.data.signType, 
                  paySign: res.data.data.paySign, 
                  success: function(res) {
                    window.location.href =  `/dist/?code=${localStorage.getItem('code')}&state=1#/info?iccid=${that.iccid}`
                  }
                })
              }else{
                // console.log("H5支付");
                // document.form.method= "post";     
                // document.form.action= res.data.data.mwebUrl;
                // document.form.submit(); 
                window.location.href = res.data.data.mwebUrl;
              }
            }else{
              this.$toast.fail(res.data.message);
            }
          })
        }else{
          this.$toast.fail("暂无套餐可充值");
        }
    },
    // 判断是否是微信浏览器
    isWeiXin() {
      let ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {},
  mounted(){
    window.document.title ="短信套餐";
    this.initProduct();
  }
};
</script>
<style scoped lang="less">
  .page{
    .d_c{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
      }
    }
    .msg-nav-title{
      color: #fff;
      font-size: 18px;
      background-color: rgb(249, 64, 64);
      height: 40px;
      line-height: 40px;
    }
    .divHeight{
      width: 100%;
      height: 15px;
      background: #EDEDED;
    }
    .msg-msisdn{
        padding-left:10px ;
        height: 40px;
        line-height: 40px;
        color: #222;
        font-weight: normal;
        font-size: 1rem;
    }
    .msg-product-title{
      padding-left:10px ;
      height: 40px;
      line-height: 40px;
      font-size: 0.8rem;
      color: #666;
    }
    .msg-product-container{
      margin:0px;
      padding: 0px;
      .row-product{
        margin-top:10px ;
        margin-left: 7px;
        margin-right: 7px;
        border: 2px solid #ededed;
        border-radius: 8px;
        font-size: 0.95rem;
        color: #2c3038;
        font-weight: normal;
        .nut-row{
          height: 35px;
          line-height: 35px;
        }
        .row-product-desc{
          font-size: 0.7rem;
        }
        .row-product-show{
          text-decoration: line-through;
        }
      }
      .row-product-radio{
        line-height:72px
      }
    }
    .msg-button-pay{
      margin-top: 2rem;
    }
    
  }
</style>

